import { showToastMessage } from "@src/toast/useToast"

// Error message mappings for different status codes
export const ERROR_MESSAGES: Record<number, { title: string; message: string }> = {
  400: {
    title: "Bad Request",
    message: "The request was invalid. Please check your input and try again.",
  },
  401: {
    title: "Unauthorized",
    message: "You are not authorized to perform this action. Please log in again.",
  },
  403: {
    title: "Forbidden",
    message: "You don't have permission to access this resource.",
  },
  404: {
    title: "Not Found",
    message: "The requested resource was not found.",
  },
  408: {
    title: "Request Timeout",
    message: "The request took too long to complete. Please try again.",
  },
  409: {
    title: "Conflict",
    message: "There was a conflict with the current state. Please refresh and try again.",
  },
  422: {
    title: "Validation Error",
    message: "The data you provided is invalid. Please check your input.",
  },
  429: {
    title: "Rate Limited",
    message: "Too many requests. Please wait a moment before trying again.",
  },
  500: {
    title: "Server Error",
    message: "An internal server error occurred. Please try again later.",
  },
  502: {
    title: "Bad Gateway",
    message: "The server is temporarily unavailable. Please try again later.",
  },
  503: {
    title: "Service Unavailable",
    message: "The service is temporarily unavailable. Please try again later.",
  },
  504: {
    title: "Gateway Timeout",
    message: "The server took too long to respond. Please try again later.",
  },
}

const getErrorMessage = (status: number): { title: string; message: string } => {
  return (
    ERROR_MESSAGES[status] || {
      title: "Error",
      message: `An unexpected error occurred (${status}). Please try again.`,
    }
  )
}

export const showErrorToast = (status: number) => {
  const { title, message } = getErrorMessage(status)
  showToastMessage(title, message, true)
}
